import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { FAQScaffold, IFaq } from "components/features/CompressorCommon/FAQScaffold";

const faqAsList: IFaq[] = [
    {
        question: "png-compressor-faq-why-use-question",
        answer: "png-compressor-faq-why-use-ans",
    },
    {
        question: "png-compressor-faq-batch-question",
        answer: "png-compressor-faq-batch-ans",
    },
    {
        question: "png-compressor-faq-reduce-size-question",
        answer: "png-compressor-faq-reduce-size-ans",
    },
    {
        question: "png-compressor-faq-free-question",
        answer: "png-compressor-faq-free-ans",
    },
    {
        question: "png-compressor-faq-settings-question",
        answer: "png-compressor-faq-settings-ans",
    },
    {
        question: "png-compressor-faq-best-free-question",
        answer: "png-compressor-faq-best-free-ans",
    },
    {
        question: "png-compressor-faq-support-question",
        answer: "png-compressor-faq-support-ans",
    },
    {
        question: "compressor-faq-clipsnap-image-upscaler-question",
        answer: "compressor-faq-clipsnap-image-upscaler-answer",
    },
    {
        question: "compressor-faq-clipsnap-bg-remover-question",
        answer: "compressor-faq-clipsnap-bg-remover-answer",
    },
];
const PngCompressorFaq = () => {
    return (
        <FAQScaffold
            faqAsList={faqAsList}
            sectionTitle={<Translate keyName="png-compressor-faq-title" />}
            sectionSubTitle={<Translate keyName="png-compressor-faq-sub-title" />}
        />
    );
};

export default PngCompressorFaq;
